import axios from "axios";
import { handleHttpErrors } from "../../../modules/http";

const initialState = {};

export const addSideReducer = (state = initialState, action) => {
  return state;
};

const addSite = (site, studyId) => (dispatch, getState) => {
  const body = {
    name: site,
    studyId: studyId,
  };

  return axios
    .post(`/api/site/create`, body)
    .then(() => {
      return Promise.resolve("Site created successfully");
    })
    .catch((error) => {
      const defaultMessage = error.response?.data
        ? error.response?.data
        : "There was an error while trying to add a new site!";

      return handleHttpErrors(error.request?.status, {
        default: defaultMessage,
      });
    });
};

export const mapDispatchToProps = {
  addSite,
};
